export const FIELDS_KEYS = {
  step: 'step',
  maxStep: 'maxStep',
  processingOption: 'processingOption',
  productCode: 'productCode',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  fullName: 'fullName',
  phone: 'phone',
  email: 'email',
  address: 'address',
  countryOfCitizenship: 'countryOfCitizenship',
  city: 'city',
  state: 'state',
  zip: 'zip',
  message: 'message',
  subject: 'subject',
  trademarkType: 'trademarkType',
  trademarkName: 'trademarkName',
  markDesc: 'markDesc',
  literalElements: 'literalElements',
  logoColoredVariety: 'logoColoredVariety',
  colorsInLogo: 'colorsInLogo',
  logoFile: 'logoFile',
  isIncludeLivingPersonName: 'isIncludeLivingPersonName',
  isIncludeNicknameName: 'isIncludeNicknameName',
  ownName: 'ownName',
  isOtherLivingName: 'isOtherLivingName',
  includeTranslationWords: 'includeTranslationWords',
  translation: 'translation',
  firstUseAnywhereYear: 'firstUseAnywhereYear',
  firstUseAnywhereDay: 'firstUseAnywhereDay',
  firstUseAnywhereMonth: 'firstUseAnywhereMonth',
  firstUseInCommerceYear: 'firstUseInCommerceYear',
  firstUseInCommerceDay: 'firstUseInCommerceDay',
  firstUseInCommerceMonth: 'firstUseInCommerceMonth',
  currentTrademark: 'currentTrademark',
  individualOrgOrInd: 'individualOrgOrInd',
  isNonUsBased: 'isNonUsBased',
  orgName: 'orgName',
  orgType: 'orgType',
  otherOrgType: 'otherOrgType',
  orgState: 'orgState',
  formationCountry: 'formationCountry',
  orgPosition: 'orgPosition',
  goods: 'goods',
  goodsCategory: 'goodsCategory',
  goodsServiceDetail: 'goodsServiceDetail',
  description: 'description',
  descriptions: 'descriptions',
  coOwners: 'coOwners',
  classes: 'classes',
  rush: 'rush',
  cardNumber: 'cardNumber',
  cvc: 'cvc',
  cardMonth: 'cardMonth',
  cardYear: 'cardYear',
  billingAddress: 'billingAddress',
  billingAddressCountry: 'billingAddressCountry',
  billingAddressState: 'billingAddressState',
  billingAddressAddress1: 'billingAddressAddress1',
  billingAddressAddress2: 'billingAddressAddress2',
  billingAddressCity: 'billingAddressCity',
  billingAddressZip: 'billingAddressZip',
  agreeWithTerms: 'agreeWithTerms',
  isSerialNumber: 'isSerialNumber',
  serialNumber: 'serialNumber',
  markOwnerFirstName: 'markOwnerFirstName',
  markOwnerLastName: 'markOwnerLastName',
  markOwnerPhone: 'markOwnerPhone',
  markOwnerEmail: 'markOwnerEmail',
  isAddressSame: 'isAddressSame',
  isNewAddress: 'isNewAddress',
  newAddress: 'newAddress',
  newCity: 'newCity',
  newState: 'newState',
  newZip: 'newZip',
  isNewDrawing: 'isNewDrawing',
  isMarkOwnerSame: 'isMarkOwnerSame',
  isNewMarkOwner: 'isNewMarkOwner',
  newMarkOwnerFirstName: 'newMarkOwnerFirstName',
  newMarkOwnerLastName: 'newMarkOwnerLastName',
  newMarkOwnerDescription: 'newMarkOwnerDescription',
  isNoticeOfAllowanceCovered: 'isNoticeOfAllowanceCovered',
  classesOrGoodsNotCovered: 'classesOrGoodsNotCovered',
  isExtensionOnClasses: 'isExtensionOnClasses',
  itemsCovered: 'itemsCovered',
  itemsExtension: 'itemsExtension',
  isSpecimenNeeded: 'isSpecimenNeeded',
  classType: 'classType',
  isClassesInUse: 'isClassesInUse',
  classesStillInUse: 'classesStillInUse',
  classesNoLongerInUse: 'classesNoLongerInUse',
  isSpecimenFile: 'isSpecimenFile',
  specimenFile: 'specimenFile',
  specimenUrl: 'specimenUrl',
  isExtendedInThePast: 'isExtendedInThePast',
  timesDeadlineWasExtended: 'timesDeadlineWasExtended',
  extensionReason: 'extensionReason',
  extensionReasonOther: 'extensionReasonOther',
  service: 'service',
  officeActionStatus: 'officeActionStatus',
  statementOfUseStatus: 'statementOfUseStatus',
  isOfficeAction: 'isOfficeAction',
  isKeepAlive: 'isKeepAlive',
  isCertifiedCopy: 'isCertifiedCopy',
  privacyPackage: 'privacyPackage',
  trademarkAssessment: 'trademarkAssessment',
  logoName: 'logoName',
  slogan: 'slogan',
  businessIndustry: 'businessIndustry',
  businessDescription: 'businessDescription',
  businessProducts: 'businessProducts',
  targetAudience: 'targetAudience',
  businessWebsite: 'businessWebsite',
  lettersType: 'lettersType',
  customersConception: 'customersConception',
  logoCategory: 'logoCategory',
  logoUse: 'logoUse',
  logoUseDescription: 'logoUseDescription',
};

export const LABELS = {
  [FIELDS_KEYS.markDesc]: {
    NAME: 'Name you wish to protect',
    SLOGAN: 'Slogan you wish to protect',
    LOGO: 'Please provide any word(s), letter(s), and/or number(s) that appear in your logo',
  },
};

export const PLACEHOLDERS = {
  [FIELDS_KEYS.markDesc]: {
    NAME: 'Enter the name you wish to protect',
    SLOGAN: 'Enter the slogan you wish to protect',
    LOGO: 'Enter the description of your logo',
  },
};

export const INVALID_MESSAGES = {
  [FIELDS_KEYS.markDesc]: {
    NAME: 'You must provide the name',
    SLOGAN: 'You must provide the slogan',
    LOGO: 'You must provide the description',
  },
};

export const MONTH_OPTIONS = [
  { value: '1', title: 'January' },
  { value: '2', title: 'February' },
  { value: '3', title: 'March' },
  { value: '4', title: 'April' },
  { value: '5', title: 'May' },
  { value: '6', title: 'June' },
  { value: '7', title: 'July' },
  { value: '8', title: 'August' },
  { value: '9', title: 'September' },
  { value: '10', title: 'October' },
  { value: '11', title: 'November' },
  { value: '12', title: 'December' },
];

export const DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => {
  return { value: `${i + 1}`, title: `${i + 1}` };
});

export const ORG_TYPE_OPTIONS = [
  { value: 'LLC', title: 'LLC' },
  { value: 'C Corporation', title: 'C Corporation' },
  { value: 'S Corporation', title: 'S Corporation' },
  { value: 'Nonprofit', title: 'Nonprofit' },
  { value: 'Partnership', title: 'Partnership' },
  { value: 'Sole Proprietorship', title: 'Sole Proprietorship' },
  { value: 'Trust', title: 'Trust' },
  { value: 'Other', title: 'Other' },
];

export const OTHER_ORG_TYPE_OPTIONS = [
  {
    value: 'Agency of the United States Government',
    title: 'Agency of the United States Government',
  },
  { value: 'Incorporated Association', title: 'Incorporated Association' },
  { value: 'Unincorporated Association', title: 'Unincorporated Association' },
  { value: 'Body Politic and Corporate', title: 'Body Politic and Corporate' },
  { value: 'Business Trust', title: 'Business Trust' },
  { value: 'Charitable Corporation', title: 'Charitable Corporation' },
  { value: 'Charitable Trust', title: 'Charitable Trust' },
  {
    value: 'Charitable, Non-profit Corporation',
    title: 'Charitable, Non-profit Corporation',
  },
  { value: 'Chartered Bank', title: 'Chartered Bank' },
  {
    value: 'Congressionally Chartered Nonprofit Organization',
    title: 'Congressionally Chartered Nonprofit Organization',
  },
  { value: 'Cooperative Association', title: 'Cooperative Association' },
  { value: 'Cooperative Corporation', title: 'Cooperative Corporation' },
  { value: 'Credit Union', title: 'Credit Union' },
  { value: 'Federal Agency', title: 'Federal Agency' },
  {
    value: 'Federally Chartered Credit Union',
    title: 'Federally Chartered Credit Union',
  },
  {
    value: 'Federally Chartered Corporation',
    title: 'Federally Chartered Corporation',
  },
  {
    value: 'Federally-recognized Indian Tribe',
    title: 'Federally-recognized Indian Tribe',
  },
  { value: 'Foundation', title: 'Foundation' },
  { value: 'Instrumentality', title: 'Instrumentality' },
  { value: 'Joint Stock Company', title: 'Joint Stock Company' },
  {
    value: 'Limited Liability Limited Partnership',
    title: 'Limited Liability Limited Partnership',
  },
  {
    value: 'Limited Liability Partnership',
    title: 'Limited Liability Partnership',
  },
  { value: 'Municipal Corporation', title: 'Municipal Corporation' },
  {
    value: 'National Banking Association',
    title: 'National Banking Association',
  },
  { value: 'Non-profit Association', title: 'Non-profit Association' },
  { value: 'Non-profit Corporation', title: 'Non-profit Corporation' },
  { value: 'Non-profit Organization', title: 'Non-profit Organization' },
  { value: 'Non-stock Corporation', title: 'Non-stock Corporation' },
  { value: 'Professional Corporation', title: 'Professional Corporation' },
  { value: 'Public Benefit Corporation', title: 'Public Benefit Corporation' },
  { value: 'State Agency', title: 'State Agency' },
  {
    value: 'State-recognized Indian Tribe',
    title: 'State-recognized Indian Tribe',
  },
  { value: 'State University', title: 'State University' },
  { value: 'Stock Company', title: 'Stock Company' },
  { value: 'Tax Exempt Corporation', title: 'Tax Exempt Corporation' },
];

export const EXTENSION_REASON_OPTIONS = [
  {
    value: 'Product or service research or development',
    title: 'Product or service research or development',
  },
  { value: 'Market research', title: 'Market research' },
  { value: 'Manufacturing activities', title: 'Manufacturing activities' },
  { value: 'Promotional activities', title: 'Promotional activities' },
  {
    value: 'Steps to acquire distributors',
    title: 'Steps to acquire distributors',
  },
  {
    value: 'Steps to obtain governmental approval',
    title: 'Steps to obtain governmental approval',
  },
  {
    value: 'Training regarding standards',
    title:
      'Training regarding standards (only for collective or certification marks)',
  },
  {
    value: 'Steps to acquire authorized users',
    title: 'Steps to acquire authorized users (only for certification marks)',
  },
  {
    value: 'Steps to acquire members',
    title: 'Steps to acquire members (only for collective works)',
  },
  {
    value: 'Development of standards',
    title:
      'Development of standards (only for collective or certification marks)',
  },
  { value: 'Other', title: 'Other' },
];

export const STATE_OPTIONS = Object.entries({
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  AA: 'Armed Forces Americas',
  AE: 'Armed Forces Europe, Canada, Africa and Middle East',
  AP: 'Armed Forces Pacific',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  MH: 'Republic of Marshall Islands',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}).map(([key, value]) => {
  return {
    title: value,
    value: key,
  };
});

export const COUNTRY_OPTIONS = Object.entries({
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia, Plurinational State of',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Congo, Democratic Republic of the',
  CF: 'Central African Republic',
  CG: 'Congo',
  CH: 'Switzerland',
  CI: "Côte d'Ivoire",
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands (Malvinas)',
  FM: 'Micronesia, Federated States of',
  FO: 'Faroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom of Great Britain and Northern Ireland',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia and the South Sandwich Islands',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Iran, Islamic Republic of',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: "Korea, Democratic People's Republic of",
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: "Lao People's Democratic Republic",
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova, Republic of',
  ME: 'Montenegro',
  MF: 'Saint Martin, (French part)',
  MG: 'Madagascar',
  MH: 'Marshall Islands',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'Palestine, State of',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  SI: 'Slovenia',
  SJ: 'Svalbard and Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'Sao Tome and Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten, (Dutch part)',
  SY: 'Syrian Arab Republic',
  SZ: 'Eswatini',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan, Province of China',
  TZ: 'Tanzania, United Republic of',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'United States of America',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Holy See',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela, Bolivarian Republic of',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  VN: 'Viet Nam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}).map(([key, value]) => {
  return {
    title: value,
    value: key,
  };
});

export const LETTERS_TYPE = {
  AS_IT_IS: 'AS_IT_IS',
  UPPERCASE: 'UPPERCASE',
  LOWERCASE: 'LOWERCASE',
};

export const LOGO_CATEGORY = {
  JUST_FONT: 'JUST_FONT',
  FONT_WITH_MEANING: 'FONT_WITH_MEANING',
  HANDMADE: 'HANDMADE',
  INITIALS: 'INITIALS',
  ABSTRACT_GRAPHIC: 'ABSTRACT_GRAPHIC',
  SILHOUETTE: 'SILHOUETTE',
  GEOMETRIC_SYMBOL: 'GEOMETRIC_SYMBOL',
  ILLUSTRATED_SYMBOL: 'ILLUSTRATED_SYMBOL',
  EMBLEM_AND_CRESTS: 'EMBLEM_AND_CRESTS',
  MASCOT: 'MASCOT',
};

export const LOGO_USE = {
  WEBSITE: 'WEBSITE',
  BUSINESS_STATIONARY_PRINTING: 'BUSINESS_STATIONARY_PRINTING',
  ADVERTISING: 'ADVERTISING',
  ONLINE_SOCIAL_MEDIA: 'ONLINE_SOCIAL_MEDIA',
  TSHIRT_PRINTING: 'TSHIRT_PRINTING',
  CAR_WRAP: 'CAR_WRAP',
  EMBROIDERY: 'EMBROIDERY',
  PACKAGING: 'PACKAGING',
  APP_ICON: 'APP_ICON',
  FLYER: 'FLYER',
  OTHER: 'OTHER',
};
